import { customAlphabet } from "nanoid";

export function generateId() {
  const nanoid = customAlphabet("1234567890abcdef", 16);
  return nanoid();
}
